<template>
    <div>
      <TimeWeekTable></TimeWeekTable>
    </div>
</template>

<script>
import moment from 'moment'
import TimeWeekTable from '@/components/week/TimeWeekTable.vue'

export default {
  name: 'WeekRegistrations',
  components: {
    TimeWeekTable
  },
   data: function() {
       return {
       }
   },
     beforeCreate: function() {
    if(!this.$route.params.time || !this.$route.params.time === undefined ||  !this.$route.params.time === 'NaN') {
      this.$router.replace({
          params: { time: moment().isoWeek() }
      });
    }
  }
}
</script>
